import Loader from 'react-loader-advanced'
import Plot from 'react-plotly.js'
import React from 'react'
import { axios } from 'config/axios'

export default class AutoProcProgramXScalePlot extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      fetching: false,
      fetched: false,
      data: [],
    }
  }
  // FIXME bmo 20210210
  // eslint-disable-next-line react/no-deprecated
  componentWillReceiveProps(newProps) {
    this.setState({
      fetching: true,
      fetched: false,
    })
    axios({
      method: 'GET',
      url: newProps.call(newProps.user, newProps.proposal, newProps.autoProcIntegrationIds),
    })
      .then(response => {
        const data = response.data.split('\n').slice(1).reverse().slice(1)
        const plotData = []
        for (var i = 0; i < data[0].split(',').length - 1; i = i + 2) {
          plotData.push({
            x: data.map(function (row) {
              return parseFloat(row.split(',')[0])
            }),
            y: data.map(function (row) {
              return parseFloat(row.split(',')[i + 1])
            }),
            type: 'scattergl',
            mode: 'markers+lines',
            connectgaps: true,
            name: newProps.autoProcIntegrationIds[i / 2],
          })
        }

        this.setState({
          data: plotData,
          fetching: false,
          fetched: true,
        })
      })
      .catch(() => {
        this.setState({
          fetching: false,
          fetched: false,
        })
      })
  }

  render() {
    if (this.state.data.length === 0) {
      return <p>{this.props.title}: No data to plot</p>
    }
    return (
      <Loader show={this.state.fetching}>
        <Plot
          data={this.state.data}
          layout={{
            title: this.props.title,
            autosize: true,
            useResizeHandler: true,
            style: { width: '100%', height: '100%' },
            xaxis: {
              type: 'category',
            },
          }}
        />
      </Loader>
    )
  }
}
